<template>
  <div>
    <Header />

    <!-- 毛毛蟲 -->
    <nav aria-label="breadcrumb" class="breadcrumb_box">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Profile" title="首頁">Home</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Please select a semester</li>
        </ol>
      </div>
    </nav>

    <div class="main form selectSemester">
      <a
        accesskey="c"
        class="accesskey"
        id="accesskey_c"
        href="javascript:void(0);"
        title="中央內容區塊"
        onclick="document.getElementById('accesskey_c').scrollIntoView();"
      >
        :::
      </a>

      <div class="container">
        <div class="box">
          <div class="title">
            <h2>Please select a semester</h2>
          </div>

          <!-- Loading state -->
          <div v-if="isLoading" class="bg">
            <div class="text_box">
              <p>Loading available application periods...</p>
            </div>
          </div>

          <!-- No active period message -->
          <div v-else-if="!hasActiveApply || applies.length === 0" class="bg">
            <div class="text_box">
              <p>There is no active application period available at this time.</p>
            </div>
          </div>

          <!-- Display available semesters -->
          <template v-else>
            <div class="bg" v-for="(apply, index) in applies" :key="apply.aId">
              <div class="title_box" @click="toggleAccordion(index)">
                <h3>{{ getSemesterTitle(apply) }}</h3>
                <div :class="['btn_add', { active: apply.open }]">
                  <div></div>
                </div>
              </div>

              <div :class="['text_box', { add: apply.open }]">
                <div class="semester-info">
                  <p><strong>Application Period:</strong></p>
                  <p>{{ formatDateTime(apply.applyStartDate, apply.applyStartHours, apply.applyStartMinutes) }} - {{ formatDateTime(apply.applyEndDate, apply.applyEndHours, apply.applyEndMinutes) }}</p>
                  
                  <p v-if="apply.announcementUrl" style="margin-top: 10px;">
                    <strong>Announcement:</strong> 
                    <a :href="apply.announcementUrl" target="_blank" rel="noopener noreferrer">View Details</a>
                  </p>
                </div>

                <div class="btn_box">
                  <button class="btn" @click="selectSemester(apply)">Apply</button>
                </div>
              </div>
            </div>
          </template>
          
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import applyStudentService from '@/services/applyStudent';
import authService from '@/services/auth';
import Swal from 'sweetalert2';

export default {
  name: "SelectSemester",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      isLoading: true,
      hasActiveApply: false,
      applies: [],
    };
  },

  async mounted() {
    window.scrollTo(0, 0);
    await this.loadAvailableSemesters();
  },

  methods: {
    async loadAvailableSemesters() {
      try {
        this.isLoading = true;

        // 檢查是否有進行中的學期梯次
        const result = await applyStudentService.checkActiveApplyPeriod();

        if (!result.success) {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: result.message || 'Failed to check active apply period',
            confirmButtonColor: '#4d167d',
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
          this.hasActiveApply = false;
          this.isLoading = false;
          return;
        }

        this.hasActiveApply = result.data?.hasActiveApply || false;
        this.applies = result.data?.applies || [];

        // 為每個學期梯次新增 open 狀態
        this.applies = this.applies.map(apply => ({
          ...apply,
          open: false
        }));

        // 如果只有一個學期梯次，預設展開
        if (this.applies.length === 1) {
          this.applies[0].open = true;
        }

      } catch (error) {
        console.error('Error loading available semesters:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Unexpected Error',
          text: 'An unexpected error occurred while loading semesters',
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } finally {
        this.isLoading = false;
      }
    },

    toggleAccordion(index) {
      this.applies[index].open = !this.applies[index].open;
    },

    getSemesterTitle(apply) {
      // 格式: 114學年度第1學期 - 測試用1
      const enrollClass = apply.enrollClass === 1 ? 'Fall' : 'Spring';
      return `${apply.enrollYear} Academic Year - ${enrollClass} Semester - ${apply.name}`;
    },

    formatDateTime(date, hours, minutes) {
      if (!date) return '';
      
      const dateObj = new Date(date);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      const hoursStr = String(hours).padStart(2, '0');
      const minutesStr = String(minutes).padStart(2, '0');
      
      return `${year}/${month}/${day} ${hoursStr}:${minutesStr}`;
    },

    async selectSemester(apply) {
      try {
        // 儲存選擇的學期梯次 aId 到 localStorage
        localStorage.setItem('selectedApplyId', apply.aId.toString());

        // 清空使用者的同意條款狀態
        const clearResult = await authService.clearReviewAndAgree();
        
        if (!clearResult.success) {
          console.warn('Failed to clear review and agree status, but continuing...');
        }

        // 檢查是否有資格審核的步驟
        const eligibilityResult = await applyStudentService.hasActiveApplyEligibility();
        
        if (eligibilityResult.success && eligibilityResult.data?.hasEligibility === true) {
          // 有資格審核，導向資格審核頁面
          this.$router.push("/QualificationForm").then(() => {
            window.scrollTo(0, 0);
          });
        } else {
          // 沒有資格審核，導向條款頁面
          this.$router.push("/Terms").then(() => {
            window.scrollTo(0, 0);
          });
        }
      } catch (error) {
        console.error('Error selecting semester:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'An error occurred while selecting semester. Please try again.',
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
    },
  },
};
</script>

<style scoped>
.semester-info {
  margin-bottom: 20px;
}

.semester-info p {
  margin: 5px 0;
}
</style>
